interface StepConfig {
  label: string;
  title: string;
  description?: string;
  helpText?: string;
  tipText?: string;
}

export const createSteps: StepConfig[] = [
  {
    label: "Role",
    title: "Define Agent Role",
    description: "Determine the core identity and function of your AI.",
    helpText:
      "Choose the role that best defines what your agent will do. This choice influences the subsequent configuration and suggested toolset.",
    tipText:
      '💡 Tip: Well defined role leads to better performance and fewer hallucinations."',
  },
  {
    label: "Intent",
    title: "Specify Agent Intent",
    // description:
    //   "Cleary articulate the primary objective or intent of the agent.",
    helpText:
      "Provide a concise, specific prompt that defines what the agent should achieve. This is the System Prompt that guides the LLM's behavior. Use precise language, constraints, and output formats.",
    // tipText:
    //   '💡 Tip: Start with "You are an expert..." and include constraints, like "Respond in JSON format only."',
    tipText:
      "💡 Tip: Primary objective or intent of the agent.",
  },
  {
    label: "Tools",
    title: "Select Agent Tools",
    helpText:
      "Select the APIs, databases, or functions the agent can call to fulfill its intent. An agent can only use tools explicitly enabled here. Drag and drop to prioritize tools if necessary.",
    tipText:
      "💡 Tip: You can optionally add tools to your agents by selecting from the catalog, creating custom tools, or combining both.",
  },
  {
    label: "LLM Settings",
    title: "Configure LLM Settings",
    // description:
    //   "Fine-tune the underlying Large Language Model (LLM) behavior.",
    // helpText:
    //   "Adjust parameters like Temperature (for creativity/randomness), Max Tokens (for output length), and select the specific Model version (e.g., GPT-4, Gemini Pro). Higher temperature means more creative but less predictable output.",
    tipText:
      "💡 Tip: Fine-tune the underlying Large Language Model (LLM) behavior.",
    //   "💡 Tip: For factual or safety-critical roles, set the Temperature closer to 0.1. For creative roles (e.g., writing), use 0.7 or higher.",
  },
  {
    label: "Knowledge Collection and Create Agent",
    title: "Knowledge Collection and Create Agent",
    // description:
    //   "Attach knowledge, finalize configuration, and launch your agent.",
    helpText:
      "1. Select a pre-processed Document Collection to provide external, private knowledge to the agent. 2. Review role, intent, tools, and LLM settings. Click Create Agent.",
    tipText:
      "🎉 Choose a Document Collection if your agent needs document knowledge. Review everything and create agent",
  },
];

export const editSteps: StepConfig[] = [
  {
    label: "Role",
    title: "Define Agent Role",
    description: "Determine the core identity and function of your AI.",
    helpText:
      "Choose the role that best defines what your agent will do. This choice influences the subsequent configuration and suggested toolset.",
    tipText:
      '💡 Tip: Well defined role leads to better performance and fewer hallucinations."',
  },
  {
    label: "Intent",
    title: "Specify Agent Intent",
    // description:
    //   "Cleary articulate the primary objective or intent of the agent.",
    helpText:
      "Provide a concise, specific prompt that defines what the agent should achieve. This is the System Prompt that guides the LLM's behavior. Use precise language, constraints, and output formats.",
    // tipText:
    //   '💡 Tip: Start with "You are an expert..." and include constraints, like "Respond in JSON format only."',
    tipText:
      "💡 Tip: Primary objective or intent of the agent.",
  },
  {
    label: "Tools",
    title: "Select Agent Tools",
    helpText:
      "Select the APIs, databases, or functions the agent can call to fulfill its intent. An agent can only use tools explicitly enabled here. Drag and drop to prioritize tools if necessary.",
    tipText:
      "💡 Tip: Would you like your agent to use any tools?",
  },
  {
    label: "LLM Settings",
    title: "Configure LLM Settings",
    // description:
    //   "Fine-tune the underlying Large Language Model (LLM) behavior.",
    // helpText:
    //   "Adjust parameters like Temperature (for creativity/randomness), Max Tokens (for output length), and select the specific Model version (e.g., GPT-4, Gemini Pro). Higher temperature means more creative but less predictable output.",
    tipText:
      "💡 Tip: Fine-tune the underlying Large Language Model (LLM) behavior.",
    //   "💡 Tip: For factual or safety-critical roles, set the Temperature closer to 0.1. For creative roles (e.g., writing), use 0.7 or higher.",
  },
  {
    label: "Knowledge Collection and Edit Agent",
    title: "Knowledge Collection and Edit Agent",
    // description:
    //   "Attach knowledge, finalize configuration, and launch your agent.",
    helpText:
      "1. Select a pre-processed Document Collection to provide external, private knowledge to the agent. 2. Review role, intent, tools, and LLM settings. Click Update Agent.",
    tipText:
      "🎉 Choose a Document Collection if your agent needs document knowledge. Review everything and update agent",
  },
];

// Step 0 
export const roleOptions = [
    "Marketplace Operations Manager",
    "Creative Director",
    "HR Talent Partner",
    "Product Manager",
    "Developer",
    "Quality Analyst",
    "Business Analyst",
    "Data Researcher",
    "Legal Expert",
    "UX Designer",
    "Project Lead",
    "Customer Success",
    "Marketing Analyst",
  ];

// Step 1: Intent creation
  export const intentOptions:any = {
    "Marketplace Operations Manager": [
      "maximize shipment-driver matches",
      "analyze delivery performance",
      "manage shipment tracking",
      "handle customer inquiries"
    ],
    "Creative Director": [
      "generate creative campaigns",
      "brainstorm new product ideas",
      "develop brand strategies",
      "create marketing content",
      "conduct market research"
    ],
    "HR Talent Partner": [
      "sourcing candidates",
      "screening resumes",
      "conducting interviews",
      "onboarding new hires",
      "employee engagement"
    ],
    "Product Manager": [
      "creating PRDs",
      "doing market analysis",
      "doing competitive analysis",
      "feature prioritization",
      "user persona research",
      "roadmap planning"
    ],
    "Developer": [
      "generating API documentation",
      "code review automation",
      "bug triage",
      "test case generation",
      "refactoring suggestions"
    ],
    "Quality Analyst": [
      "creating static accessibility testing reports",
      "automating regression test suites",
      "performance benchmarking",
      "security vulnerability scanning"
    ],
    "Business Analyst": [
      "requirements gathering",
      "process mapping",
      "stakeholder analysis",
      "KPI dashboard creation"
    ],
    "Data Researcher": [
      "data cleaning",
      "exploratory data analysis",
      "trend forecasting",
      "dataset annotation"
    ],
    "Legal Expert": [
      "contract review",
      "compliance checklist generation",
      "risk assessment",
      "policy drafting"
    ],
    "UX Designer": [
      "user journey mapping",
      "usability testing",
      "wireframe generation",
      "accessibility audit"
    ],
    "Project Lead": [
      "resource allocation",
      "timeline estimation",
      "risk tracking",
      "status reporting"
    ],
    "Customer Success": [
      "migrating customer's video assets to my company",
      "onboarding new clients",
      "support ticket triage",
      "customer feedback analysis"
    ],
    "Marketing Analyst": [
      "campaign performance analysis",
      "lead scoring",
      "market segmentation",
      "content strategy planning"
    ]
  };

  export const toolSuggestions:any = {
    "Creative Director": [
      // { name: "Web Search", description: "Search the web for information.", params: ["query"] },
      // { name: "Content Generator", description: "Generate marketing content.", params: ["topic", "length"] },
      // { name: "Brand Analyzer", description: "Analyze brand performance.", params: ["brand_name"] }
    ],
    "HR Talent Partner": [
      // { name: "Resume Parser", description: "Extracts key information from resumes.", params: ["resume_text"] },
      // { name: "Interview Scheduler", description: "Schedules interviews with candidates.", params: ["candidate_email", "interview_date"] },
      // { name: "Candidate Sourcing", description: "Finds potential candidates based on job requirements.", params: ["job_description"] },
    ],
    "Product Manager": [
      { name: "Web Search", description: "Search the web for information.", params: ["query"] },
      { name: "Data Scraper", description: "Extract data from web pages.", params: ["url", "selector"] },
      { name: "Competitor Info Fetcher", description: "Fetch competitor details.", params: ["company_name"] }
    ],
    "Developer": [
      // { name: "Code Review Tool", description: "Automate code review.", params: ["repo_url"] },
      // { name: "API Doc Generator", description: "Generate API documentation.", params: ["source_code"] }
    ],
    "Quality Analyst": [
      { name: "Accessibility Checker", description: "Run accessibility tests.", params: ["url"] },
      { name: "Performance Tester", description: "Benchmark web performance.", params: ["url"] }
    ],
    "Business Analyst": [
      { name: "KPI Dashboard Generator", description: "Create KPI dashboards.", params: ["data_source"] },
      { name: "Process Mapper", description: "Map business processes.", params: ["process_description"] }
    ],
    "Data Researcher": [
      { name: "Data Cleaner", description: "Clean and preprocess data.", params: ["dataset"] },
      { name: "Trend Forecaster", description: "Forecast data trends.", params: ["historical_data"] }
    ],
    "Legal Expert": [
      { name: "Contract Analyzer", description: "Analyze legal contracts.", params: ["contract_text"] },
      { name: "Compliance Checker", description: "Check compliance requirements.", params: ["document"] }
    ],
    "UX Designer": [
      { name: "Usability Tester", description: "Test usability of designs.", params: ["design_url"] },
      { name: "Wireframe Generator", description: "Generate wireframes.", params: ["requirements"] }
    ],
    "Project Lead": [
      { name: "Resource Allocator", description: "Allocate project resources.", params: ["project_plan"] },
      { name: "Timeline Estimator", description: "Estimate project timelines.", params: ["tasks"] }
    ],
    "Customer Success": [
      { name: "Asset Migrator", description: "Migrate customer assets.", params: ["source", "destination"] },
      { name: "Feedback Analyzer", description: "Analyze customer feedback.", params: ["feedback_data"] }
    ],
    "Marketing Analyst": [
      { name: "Campaign Analyzer", description: "Analyze marketing campaigns.", params: ["campaign_data"] },
      { name: "Lead Scorer", description: "Score marketing leads.", params: ["lead_list"] }
    ],
    "Customer Support Assistant": [
      { name: "FAQ Retriever", description: "Retrieve answers from FAQ database.", params: ["question"] },
      { name: "Ticket Creator", description: "Create support tickets.", params: ["customer_id", "issue"] }
    ]
  };

  export const llmOptions = ["Google", "Anthropic", "OpenAI"];
